export default {"src":"kbwebsite/assets/_next/static/media/iso.afacbc9a.svg","height":40,"width":44};